import { RefObject } from 'react'
import './codeEditor.css'

export type CodeEditorProps = {
  visible: boolean
  editorRef: RefObject<HTMLDivElement>
  onClose?: () => void
  /** コードをクリップボードへコピーする。コピー手段を提供する場合のみ渡す。 */
  onCopy?: () => void
  /** コピーボタンのラベル（i18n 済みの文言）。 */
  copyLabel?: string
}

export default function CodeEditor(props: CodeEditorProps) {
  return (
    <div
      className="code-editor-wrapper"
      style={{ bottom: props.visible ? 0 : undefined }}
    >
      <div className="code-editor" ref={props.editorRef} />
      {props.visible && props.onCopy && (
        // アプリ全体で文字選択を無効化しているため、コードの手選択コピーに
        // 代わる明示的なコピー手段を提供する（タッチ端末でもコピーできる）。
        // 非表示時（画面外退避）は Tab/支援技術から触れないよう描画しない。
        <button
          type="button"
          className="code-editor-copy"
          onClick={props.onCopy}
        >
          {props.copyLabel}
        </button>
      )}
      <div className="code-editor-close" onClick={props.onClose}>
        ×
      </div>
    </div>
  )
}
